import { wealthProApi } from '../../redux/api';
import { buildSearchParamsString } from '../../redux/helpers';

const hoAdminPlatformTransactionApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["PlatformTransactions", "TransactionMatches"]
}).injectEndpoints({
    endpoints: (builder) => ({
        bulkResolveExceptions: builder.mutation({
            query: (request) => ({
                url: 'api/headofficeadmin/platformtransactions/resolve-bulk',
                method: 'POST',
                body: request
            })
        }),
        fetchHeadOfficePlatformTransactionExceptions: builder.query({
            query: ({ page = 1, limit, search }) => buildSearchParamsString(`api/headofficeadmin/platformTransactions/exceptions`, { page, limit, search }),
            serializeQueryArgs: ({ endpointName }) => endpointName,
            providesTags: ["TransactionMatches"]
        }),
        fetchHeadOfficePotentialTransactionMatches: builder.query({
            query: ({ id }) => `api/headofficeadmin/platformTransactions/${id}/potentialMatches`,
            providesTags: (res, err, { id }) => ["TransactionMatches", { id, type: "TransactionMatches" }]
        }),
        resolveHeadOfficeException: builder.mutation({
            query: (request) => ({
                url: 'api/headofficeadmin/platformTransactions/resolve',
                method: 'POST',
                body: request
            })
        }),
        retryPlatformTransactionMatching: builder.mutation({
            query: () => ({
                url: 'api/headofficeadmin/platformTransactions/retry-matching',
                method: 'POST'
            }),
            invalidatesTags: ["TransactionMatches"]
        }),
        fetchHubwiseTransactionExceptions: builder.query({
            query: ({ page = 1, limit }) => buildSearchParamsString(`api/headofficeadmin/platformTransactions/exceptions`, { custodianCode: "HUBW", page, limit }),
            serializeQueryArgs: ({ endpointName }) => endpointName,
            merge: (currentCache, newItems) => {
                const { pagination: { page: currentPage } } = currentCache || { pagination: {} };
                const { pagination: { page: nextPage } } = newItems || { pagination: {} };

                if (!currentPage || nextPage <= currentPage)
                    return newItems;

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results);
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            }
        })
    })
});

export const {
    useFetchHeadOfficePlatformTransactionExceptionsQuery,
    useLazyFetchHeadOfficePotentialTransactionMatchesQuery,
    useResolveHeadOfficeExceptionMutation,
    useRetryPlatformTransactionMatchingMutation,
    useBulkResolveExceptionsMutation,
    useLazyFetchHubwiseTransactionExceptionsQuery
} = hoAdminPlatformTransactionApiEndpoints;